// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2024":"3793ec5044ccda62","4289":"f9dca757db24ab76","4456":"c92d3b743144863b","4492":"27be49994b8a23c2","5660":"5bd7653ac485632f","7704":"7806cf0d44f26c43","8987":"b3cc3e5c3a0cffcb"}[chunkId] + ".css";
};